import dayjs from 'dayjs';
import * as DateString from '../DateString';
import * as TimeString from '../TimeString';
export const fromSpecialCase = ({ start, end, }) => {
    const startDate = dayjs.utc(start);
    const endDate = dayjs.utc(end);
    return {
        startDay: DateString.fromDate(startDate),
        startTime: TimeString.fromDate(startDate),
        endDay: DateString.fromDate(endDate),
        endTime: TimeString.fromDate(endDate),
    };
};
export const fromScheduleItem = (item) => ({
    startDay: item.openDay,
    startTime: item.openTime,
    endDay: item.closeDay,
    endTime: item.closeTime,
});
export const breakInterval = (iterator) => ({ startDay, startTime, endDay, endTime, }) => {
    if (endTime === '00:00') {
        endTime = '23:59';
        endDay = iterator.prev(endDay);
    }
    if (startDay === endDay) {
        return [{ day: startDay, open: startTime, close: endTime }];
    }
    const res = [];
    for (let currDay = startDay, i = iterator.distance(endDay, startDay); i >= 0; 
    // eslint-disable-next-line no-restricted-syntax
    currDay = iterator.next(currDay), --i) {
        if (currDay === startDay) {
            res.push({ day: currDay, open: startTime, close: '23:59' });
            continue;
        }
        if (currDay === endDay) {
            res.push({ day: currDay, open: '00:00', close: endTime });
            continue;
        }
        res.push({ day: currDay, open: '00:00', close: '23:59' });
    }
    return res;
};
//# sourceMappingURL=DateTimeInterval.js.map